import React from 'react';
import { Check, X } from 'lucide-react';
import { Button } from './ui/button';

interface SelectedPickRowProps {
  label: string;
  logoUrl?: string;
  success?: boolean;
  tournamentStarted: boolean;
  onRemove: () => void;
}

const SelectedPickRow: React.FC<SelectedPickRowProps> = ({
  label, logoUrl, success, tournamentStarted, onRemove
}) => (
  <div className="flex items-center bg-gray-800 border border-gray-700 px-3 py-2 rounded text-gray-200">
    {logoUrl && <img src={logoUrl} alt={label} className="h-6 w-6 ml-2" />}
    <span className="flex-grow">{label}</span>
    {tournamentStarted ? (
      success && <Check className="h-4 w-4 text-green-400" />
    ) : (
      <Button
        variant="ghost"
        size="sm"
        onClick={onRemove}
        className="h-8 w-8 p-0 text-gray-400 hover:text-stake-blue"
      >
        <X className="h-4 w-4" />
      </Button>
    )}
  </div>
);

export default SelectedPickRow;
